import axios from "axios";
import _ from "lodash";
import axiosRetry from "axios-retry";

axiosRetry(axios, { retries: 3 });

const state = {
  selectedArea: {},
  division: [
    { label: "Imaging (Regions)", value: "Imaging" },
    { label: "Diagnostic (Regions)", value: "Diagnostics" },
    { label: "Imaging (Zones)", value: "ImagingZone" },
  ],
  selectedDivision: { label: "Imaging (Regions)", value: "Imaging" },
  areas: [],

  colorCoding: {
    0: "#c7522a",
    1: "#cf6e41",
    2: "#d68a58",
    3: "#dea66f",
    4: "#e5c185",
    5: "#f0daa5",
    6: "#8fbf8a",
    7: "#4a8f72",
    8: "#008585",
    9: "#006767",
  },
};

const getters = {
  division: (state) => state.division,
  selectedDivision: (state) => state.selectedDivision,
  areas: (state) => state.areas,
  selectedArea: (state) => state.selectedArea,
};

const mutations = {
  setSelectedDivision(state, val) {
    state.selectedDivision = { ...val };
  },
  setAreas(state, obj) {
    state.areas = [...obj];
  },
  setSelectedArea(state, obj) {
    state.selectedArea = _.cloneDeep(obj);
  },
};

const actions = {
  async loadAreas({ commit, rootGetters, state, dispatch }) {
    try {
      const res = await axios.get(
        rootGetters.backendURL +
          "/api/service_areas/" +
          rootGetters.selectedCountry.iso_3166_1
      );
      // console.log(axios.defaults.headers.common);
      let mappedColorArr = res.data.map((obj) => ({
        ...obj,
        color: state.colorCoding[obj.color_index],
      }));

      commit("setAreas", mappedColorArr);
    } catch (err) {
      console.log(err);
      dispatch("pushNotification", {
        type: "error",
        label: "Get Areas failed",
        text: "Areas unavailable",
        duration: "long",
      });
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
